import { ExternalLink, FlaskConical } from "lucide-react";
import { AMBIENTE_PRODUCTIVO, ETIQUETA_AMBIENTE, URL_PRODUCCION } from "@/lib/ambiente";

/**
 * Banda permanente que identifica un ambiente no productivo.
 *
 * Va pegada arriba de todo, en todas las pantallas —también en el login—, con
 * un color que no existe en ningún otro lugar de la interfaz y sin botón de
 * cerrar: la confusión que la motivó ocurrió precisamente a alguien que ya
 * había iniciado sesión y navegaba con normalidad. En producción no se dibuja.
 */
export function BandaAmbiente() {
  if (AMBIENTE_PRODUCTIVO || !ETIQUETA_AMBIENTE) return null;

  return (
    <div
      role="status"
      aria-label={`${ETIQUETA_AMBIENTE}. No es el sistema productivo.`}
      className="banda-ambiente flex flex-wrap items-center justify-center gap-x-3 gap-y-1 py-1.5 text-center text-xs font-semibold text-amber-950 sm:text-sm"
    >
      <span className="inline-flex items-center gap-1.5 uppercase tracking-wide">
        <FlaskConical className="h-4 w-4 shrink-0" aria-hidden="true" />
        {ETIQUETA_AMBIENTE}
      </span>
      <span className="font-normal">
        No es el sistema productivo: lo que captures aquí no tiene validez oficial.
      </span>
      <a
        href={URL_PRODUCCION}
        rel="noopener"
        className="inline-flex items-center gap-1 rounded border border-amber-950/40 bg-white/60 px-2 py-0.5 font-semibold underline-offset-2 hover:bg-white hover:underline"
      >
        Ir al SICEN productivo
        <ExternalLink className="h-3 w-3" aria-hidden="true" />
      </a>
    </div>
  );
}
